module.exports = __webpack_public_path__ + "index/img/icon_shouhou.491e21aa.svg";